import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TProps, IDeps } from './models';
import { PropsOverrider as Component } from './component';

/**
 * Отображение данных из контекста с данными для детальной страницы, перезаписывает данные дочернего виджета на данные из контекста
 * */
export const SmePartnersCommonPropsOverrider = createWidget<IDeps, TProps>({})(Component);
